import { MantineProvider, v8CssVariablesResolver } from "@mantine/core";
import { useFeatureFlagEnabled, usePostHog } from "posthog-js/react";
import {
  emotionTransform,
  Global,
  MantineEmotionProvider,
} from "@mantine/emotion";
import { css } from "@emotion/react";

import { themeV1 } from "./themeV1";
import { themeV2 } from "./themev2";
import { themeV2CssVariablesResolver } from "./themev2/cssVariablesResolver";

interface Props {
  children: React.ReactNode;
  version?: "v1" | "v2";
}

export const MantineJasperThemeProvider = ({ children, version }: Props) => {
  const posthog = usePostHog();
  const isThemeV2Enabled = useFeatureFlagEnabled("theme_v2");

  // Waiting theme to load. Prevent flickering between v1 and v2 theme
  if (posthog.__loaded && isThemeV2Enabled === undefined && !version) {
    return null;
  }

  const isV2 = version === "v2" || (isThemeV2Enabled && version !== "v1");
  const appTheme = isV2 ? themeV2 : themeV1;
  const cssVariablesResolver = isV2
    ? themeV2CssVariablesResolver
    : v8CssVariablesResolver;

  return (
    <MantineEmotionProvider>
      <MantineProvider
        cssVariablesResolver={cssVariablesResolver}
        stylesTransform={emotionTransform}
        theme={appTheme}
      >
        <Global
          styles={css`
            @import url("https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap");
            @import url("https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700;800&display=swap");
            @import url("https://api.fontshare.com/v2/css?f%5B%5D=general-sans@400,500,600,700&display=swap");
          `}
        />
        {children}
      </MantineProvider>
    </MantineEmotionProvider>
  );
};
